import { buildAssistantUrl, buildAssistantHeaders } from "./assistantApi";

/**
 * Send message feedback (thumbs up/down) to the assistant backend.
 * Uses trace_id from the SSE end event (SSE streaming protocol spec).
 * Always sends a request when called so the call is visible in DevTools;
 * backend may return 422/501/503 when traceId is missing or Langfuse is disabled.
 *
 * @param {Object} params
 * @param {string|null|undefined} params.traceId - trace_id from end event metadata
 * @param {number} params.value - 1 = thumbs up, 0 = thumbs down
 * @param {string} [params.comment] - Optional user comment
 * @returns {Promise<boolean>} - True if request succeeded (2xx), false otherwise
 */
export const sendMessageFeedback = async ({ traceId, value, comment = "" }) => {
  const traceIdStr = typeof traceId === "string" && traceId ? traceId : "";
  if (!traceIdStr) {
    console.warn("[AI Assistant] sendMessageFeedback: no traceId (end event may not include metadata.trace_id)");
  }

  const payload = {
    traceId: traceIdStr,
    value: value === 1 ? 1 : 0,
    comment: typeof comment === "string" ? comment : "",
  };

  try {
    const response = await fetch(buildAssistantUrl("feedback/"), {
      method: "POST",
      headers: buildAssistantHeaders(),
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      console.warn("[AI Assistant] sendMessageFeedback non-OK response", response.status, await response.text());
      return false;
    }
    return true;
  } catch (err) {
    console.warn("[AI Assistant] sendMessageFeedback failed", err);
    return false;
  }
};
